import { Button } from "@/components/ui/button";
import { Flame, Home, ArrowLeft } from "lucide-react";
import { useLocation } from "wouter";

export default function NotFound() {
  const [, setLocation] = useLocation();

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-background p-4">
      <div className="text-center max-w-md">
        <div className="flex items-center justify-center gap-3 mb-6">
          <div className="p-3 bg-primary/20 rounded-xl">
            <Flame className="w-10 h-10 text-primary animate-pulse" />
          </div>
        </div>
        
        <h1 className="text-6xl font-bold text-primary mb-2">404</h1>
        <h2 className="text-2xl font-semibold text-foreground mb-4">
          Workout Not Found
        </h2>
        <p className="text-muted-foreground mb-8">
          Looks like this page took a rest day. Let's get you back to crushing your goals!
        </p>
        
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            onClick={() => window.history.back()}
            variant="outline"
            className="gap-2"
            data-testid="button-go-back"
          >
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </Button>
          <Button
            onClick={() => setLocation("/")}
            className="gap-2"
            data-testid="button-go-home"
          >
            <Home className="w-4 h-4" />
            Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
}
